import React, {useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
import './Home.css';
import productData, { getProductImageStyle, getProductDescriptionStyle } from '../data/productData';

const Home = () => {
  // 检测设备类型
  const [deviceType, setDeviceType] = useState(window.innerWidth > 768 ? 'desktop' : 'mobile');

  // 获取产品图片
  const getProductImage = (product) => {
    try {
      return require(`../assets/images/products/${product.image}`);
    } catch (e) {
      // 如果找不到图片，使用默认图片
      return require('../assets/images/products/default-product.svg');
    }
  };

  // 监听窗口大小变化
  useEffect(() => {
    const handleResize = () => {
      setDeviceType(window.innerWidth > 768 ? 'desktop' : 'mobile');
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="home-page">
      {/* 轮播图部分 */}
      <section className="banner-section">
        <div className="banner">
          <div className="banner-content">
            <h1 className="banner-title">为实时而生，为连接而来</h1>
            <div className="banner-line"></div>
          </div>
          {/* <div className="banner-indicators">
            <div className="indicator active"></div>
            <div className="indicator"></div>
            <div className="indicator"></div>
            <div className="indicator"></div>
          </div> */}
        </div>
      </section>

      {/* 产品中心部分 */}
      <section className="products-section">
        <div className="section-container">
          <div className="section-header">
            <h2>精选产品</h2>
            <p>集成多媒体技术，打造数字化通讯生态</p>
          </div>
          <div className="products-slider">
            {productData.featuredProducts.map(product => {
              // 获取当前产品的样式
              const imageStyle = getProductImageStyle(product, deviceType);

              return <div className="product-card" key={product.id}>
                <h3 className="home-product-title up">{product.name}</h3>
                <div className="product-image" style={{...imageStyle}}>
                  <img src={getProductImage(product)} alt={product.name} />
                </div>
                <div className="home-product-info">
                  <h3 className="home-product-title down">{product.name}</h3>
                  <p>{product.desc}</p>
                  <Link to={`/products/${product.series}/${product.id}`} className="view-details">查看详情</Link>
                </div>
              </div>
            })}
          </div>
        </div>
      </section>

      {/* 解决方案部分 */}
      {/* <section className="solutions-section">
        <div className="section-container">
          <div className="section-header">
            <h2>解决方案</h2>
            <p>专注于教育和视讯领域，提供专业的数字化解决方案</p>
          </div>
          <div className="solutions-grid">
            <div className="solution-card">
              <div className="solution-icon">
                <img src="/images/icon-classroom.png" alt="远程教学" />
              </div>
              <h3>远程互动教学</h3>
              <p>消除地域限制，让教育资源普惠共享</p>
              <Link to="/solutions/remote-teaching" className="learn-more">了解更多</Link>
            </div>
            <div className="solution-card">
              <div className="solution-icon">
                <img src="/images/icon-recording.png" alt="互动录播" />
              </div>
              <h3>精品互动录播</h3>
              <p>捕捉教学精彩瞬间，沉淀优质教学资源</p>
              <Link to="/solutions/interactive-recording" className="learn-more">了解更多</Link>
            </div>
            <div className="solution-card">
              <div className="solution-icon">
                <img src="/images/icon-normal.png" alt="常态录播" />
              </div>
              <h3>常态互动录播</h3>
              <p>简化录播流程，实现教学全程记录</p>
              <Link to="/solutions/normal-recording" className="learn-more">了解更多</Link>
            </div>
            <div className="solution-card">
              <div className="solution-icon">
                <img src="/images/icon-collaboration.png" alt="视频协作" />
              </div>
              <h3>视频交互协作</h3>
              <p>打破沟通壁垒，实现远程高效协同</p>
              <Link to="/solutions/video-interaction" className="learn-more">了解更多</Link>
            </div>
          </div>
        </div>
      </section> */}

      {/* 客户案例部分 */}
      {/* <section className="cases-section">
        <div className="section-container">
          <div className="section-header">
            <h2>客户案例</h2>
            <p>服务多个行业，提供定制化解决方案</p>
          </div>
          <div className="cases-grid">
            <div className="case-card">
              <div className="case-image">
                <img src="/images/case-education.jpg" alt="教育案例" />
                <div className="case-overlay">
                  <h3>教育机构</h3>
                  <p>为全国多所学校提供远程教学解决方案</p>
                  <Link to="/cases/education" className="read-more">阅读更多</Link>
                </div>
              </div>
            </div>
            <div className="case-card">
              <div className="case-image">
                <img src="/images/case-government.jpg" alt="政府案例" />
                <div className="case-overlay">
                  <h3>政府机构</h3>
                  <p>助力政府数字化转型，提升办公效率</p>
                  <Link to="/cases/government" className="read-more">阅读更多</Link>
                </div>
              </div>
            </div>
            <div className="case-card">
              <div className="case-image">
                <img src="/images/case-corporate.jpg" alt="企业案例" />
                <div className="case-overlay">
                  <h3>企业客户</h3>
                  <p>打造高效协作环境，促进企业创新发展</p>
                  <Link to="/cases/corporate" className="read-more">阅读更多</Link>
                </div>
              </div>
            </div>
            <div className="case-card">
              <div className="case-image">
                <img src="/images/case-medical.jpg" alt="医疗案例" />
                <div className="case-overlay">
                  <h3>医疗行业</h3>
                  <p>远程医疗解决方案，提升诊疗效率</p>
                  <Link to="/cases/medical" className="read-more">阅读更多</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default Home;